import { FilterSelectItem } from "./filter-select-item";

export class PayerConfigItem {
    PayerID: number;
    PayerName: string;
    Abbreviation: string;
    Aliases: string;
    RiskAdjustmentPolicy: PayerRiskAdjustmentPolicy;
    Status: boolean;
    ReceivingMAO?: boolean;
    ReceivingMOR?: boolean;
    PayerPolicyFileSubTypeCount?: number;
}

export class PayerRiskAdjustmentPolicy {
    PolicyID: number;
    PayerID: number;
    ServiceYearStart: string;
    ServiceYearEnd: string;
    HasRiskAdjustment: boolean;
    HasManualOmit: boolean;
    PreferredActionSubmissionType: FilterSelectItem
    LastModifiedDate: string;
    Note: string;
    ASMTemplateIDs?: string;
    ASMTemplateNames?: string;
    AcceptsASMDelete: boolean | null;
    PayerValidationTemplateID?: number;
    PayerValidationTemplateName?: string;
    FileSubTypesByFileType?: FileSubTypeByFileType[];
    SubmissionLeadTimeDays?: number | null;
}

export class PayerRiskAdjustmentPolicyUpdate {
    PolicyID?: number;
    PayerID: number;
    ServiceYearStart: string;
    ServiceYearEnd: string;
    HasRiskAdjustment?: boolean;
    HasManualOmit?: boolean;
    PreferredActionSubmissionTypeID?: string;
    PreferredActionName?: string;
    Note?: string;
    ASMTemplateIDs?: string | null;
    AcceptsASMDelete?: boolean | null;
    PayerValidationTemplateID?: number | null;
    FileSubTypesByFileType?: FileSubTypeByFileType[];
    SubmissionLeadTimeDays?: number | null;
    ReceivingMAO?: boolean | null;
    ReceivingMOR?: boolean | null;
    MORVersions?: string | null;
}

export class FileSubTypeByFileType {
    FileTypeID: number;
    FileSubTypeID?: number;
}